import React, { useState } from 'react'
import StyledColorPicker from '../../../../components/StyledComponents/StyledColorPicker'
import StyledText from '../../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../../middleware/ThemeContext';
import EditIcon from '../../../../assets/icons/EditIcon';
import { WebsiteFormValues } from '../../../../types/types';
import { Skeleton } from '@mui/material';

const ThemeColors = ({ companyLoading, isResponsive, setSettingConfiguration, settingConfiguration }: { companyLoading?: boolean, isResponsive?: boolean, setSettingConfiguration: React.Dispatch<React.SetStateAction<WebsiteFormValues>>, settingConfiguration: WebsiteFormValues }) => {
    const { theme } = useTheme();
    // const [primaryColor, setPrimaryColor] = useState('#0050FF');
    // const [secondaryColor, setSecondaryColor] = useState('#F59E0B');
    // const [textColor, setTextColor] = useState('#003366');

    return (

        <div className='p-3' style={{ border: `1px solid ${theme.CorporateTheme.colors.border}`, borderRadius: '10px', backgroundColor: theme.CorporateTheme.colors.background, width: '100%' }}>
            <div className='d-flex align-items-center justify-content-between'>
                <StyledText fontSize={isResponsive ? '16px' : '18px'} fontWeight={700} textColor={theme.CorporateTheme.colors.primary}>Theme Colors</StyledText>
                {/* <EditIcon size={isResponsive ? 18 : 24} color={theme.CorporateTheme.colors.headerColor} /> */}
            </div>
            <div className='d-flex gap-3 mt-3'>
                {companyLoading ?
                    Array.from({ length: 3 }).map((_, index) => (
                        <Skeleton key={index} variant="rectangular" width={'224px'} height={'127px'} />
                    ))

                    :
                    <>
                        <StyledColorPicker
                            title='Primary Color'
                            subTitle={<>Used for <strong>Main buttons</strong>, <strong>Headers</strong> and <strong>links</strong>.</>}
                            color={settingConfiguration.primaryColor}
                            setColor={(color) => setSettingConfiguration({ ...settingConfiguration, primaryColor: color })}
                            className='col'
                            isResponsive={isResponsive}
                        />
                        <StyledColorPicker
                            title='Secondary Color'
                            subTitle={<>Used for <strong>Subheadings, borders,</strong> and <strong>icons</strong>.</>}
                            color={settingConfiguration.secondaryColor}
                            setColor={(color) => setSettingConfiguration({ ...settingConfiguration, secondaryColor: color })}
                            className='col'
                            isResponsive={isResponsive}
                        />
                        <StyledColorPicker
                            title='Text Color'
                            subTitle={<>Used for <strong>Body text, paragraphs,</strong> and <strong>descriptions</strong>.</>}
                            color={settingConfiguration.textColor}
                            setColor={(color) => setSettingConfiguration({ ...settingConfiguration, textColor: color })}
                            className='col'
                            isResponsive={isResponsive}
                        />
                    </>}
            </div>
        </div>
    )
}

export default ThemeColors
